const OFFICE_HOURS = {
  OFFICE_HEADER_TITLE: 'زمان‌های کاری',
  OFFICE_HEADER_DESC:
    'مشخص کردن ساعات کاری برای آگاهی کاربران. در زمان‌های غیرکاری نیز کاربران از دست نمی‌روند. توجه داشته باشید که آنلاین بودن در تلگرام به معنای آنلاین بودن در سیستم ما نیست.',
  OFFICE_SECTION_TITLE: 'زمان های کاری',
  ADD_OFFICE_HOURS_BTN: 'افزودن زمان کاری',
  NON_OFFICE_HOURS_TITLE: 'زمان های غیرکاری',
  EMPTY_OFFICE_HOURS_TEXT: `
  در صورتی که زمان کاری تعریف نکرده باشید، کل هفته زمان های کاری شما محسوب
  میشود و تنظیمات زمان های غیر کاری اعمال نخواهند شد.
  `,

  TIME_OPTION_WORK_DAY: 'روزهای کاری',
  TIME_OPTION_WHOLE_WEEK: 'کل هفته',
  TIME_OPTION_SATURDAY: 'شنبه',
  TIME_OPTION_SUNDAY: 'یکشنبه',
  TIME_OPTION_MONDAY: 'دوشنبه',
  TIME_OPTION_TUESDAY: 'سه شنبه',
  TIME_OPTION_WEDNESDAY: 'چهارشنبه',
  TIME_OPTION_THURSDAY: 'پنجشنبه',
  TIME_OPTION_FRIDAY: 'جمعه',

  NON_OFFICE_OFFLINE_TITLE:
    'فعال/غیرفعال کردن پیام آفلاین: دریافت اطلاعات کاربران برای تماس مجدد',
  NON_OFFICE_OFFLINE_GUIDE:
    'در صورت پاسخ دادن به کاربر از طریق ایمیل به کاربر اطلاع رسانی میشود',
  NON_OFFICE_ONLINE_TITLE: 'تغییر به حالت آنلاین',
  NON_OFFICE_ONLINE_GUIDE:
    'اگر در اپلیکیشن تحت وب، موبایل و دسکتاپ آنلاین باشید وضعیت اپراتورها بصورت آنلاین برای کاربران نمایش داده میشود ',
  NON_OFFICE_AUTO_MSG_TITLE: 'فعال/غیرفعال کردن ارسال پیام‌های هوشمند',
  NON_OFFICE_AUTO_MSG_GUIDE:
    ' در زمان های غیر کاری، پیام های هوشمند ارسال نشود ',
  NON_OFFICE_TELEGRAM_TITLE: 'ارسال پیام‌ها به تلگرام',
  NON_OFFICE_TELEGRAM_GUIDE:
    ' پیام ها به تلگرام اپراتور ها ارسال میشود اما وضعیت شما همچنان آفلاین است. ',
  NON_OFFICE_SLEEP_TITLE: 'تغیر ایکون ابزارک به حالت خواب',
  NON_OFFICE_SLEEP_GUIDE:
    'در صورت آفلاین بودن، ظاهر آیکون ابزارک به حالت خواب تغییر میکند ',
  NON_OFFICE_HIDDEN_TITLE: 'مخفی کردن ابزارک',
  NON_OFFICE_DISABLE_CHAT: 'غیرفعال کردن امکان چت',
  NON_OFFICE_DISABLE_CHAT_GUIDE:
    'غیرفعال کردن امکان ارسال پیام در ساعات غیرکاری',
  NON_OFFICE_HIDDEN_GUIDE: 'در ساعات غیر کاری ابزارک نمایش داده نمی‌شود. ',
  OFFICE_TIME_NOT_SELECTED_ERROR: 'تنظیمات روز را انتخاب کنید',
  OFFLINE_MSG_SETTINGS_SUBMIT: 'ذخیره',
  OFFLINE_MSG_SETTINGS_CANCEL: 'انصراف',

  WORK_TIME_FROM_LABEL: 'از',
  WORK_TIME_TO_LABEL: 'الی',
};

export default OFFICE_HOURS;
